// extracted by mini-css-extract-plugin
export var popper = "_7x-0";